/* Baby Joe Joe, site-wide motion. Plain JS, runs after React paints and
   re-scans whenever the view changes. */
(function () {
  if (window.__bjjMotion) return;
  window.__bjjMotion = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var line = document.createElement('div');
  line.className = 'scroll-line';
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(line); });
  if (document.body) document.body.appendChild(line);

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var d = document.documentElement;
      var max = d.scrollHeight - d.clientHeight;
      line.style.width = (max > 0 ? (d.scrollTop / max) * 100 : 0) + '%';
      document.body.classList.toggle('is-scrolled', d.scrollTop > 20);
      if (!reduce) {
        var vh = window.innerHeight;
        // Opening image: slow zoom-out and a soft fade as you leave it.
        var heroImg = document.querySelector('.hero--full .hero__img');
        if (heroImg) {
          var hb = heroImg.parentElement.getBoundingClientRect();
          var pr = Math.min(1, Math.max(0, -hb.top / Math.max(1, hb.height)));
          heroImg.style.transform = 'scale(' + (1.14 - pr * 0.14).toFixed(3) + ')';
          var inner = document.querySelector('.hero--full .hero__inner');
          if (inner) { inner.style.opacity = (1 - pr * 1.25).toFixed(3); inner.style.transform = 'translateY(' + (pr * -60).toFixed(1) + 'px)'; }
        }
        document.querySelectorAll('[data-rv]:not(.is-in)').forEach(function (el) {
          var b = el.getBoundingClientRect();
          if (b.top < vh * 0.94 && b.bottom > 0) { el.classList.add('is-in'); showWords(el); }
        });
        syncWords();
        document.querySelectorAll('[data-parallax]').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          var amt = parseFloat(el.getAttribute('data-parallax')) || 18;
          el.style.transform = 'translate3d(0,' + (-p * amt).toFixed(2) + 'px,0)';
        });
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (reduce) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in'); showWords(e.target);
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

  // Blocks that get a reveal without having to be tagged by hand.
  var SEL = [
    '.section-head', '.prod-card', '.card', '.photo', '.figure',
    '.bjj-media-slot', '.bjj-card', '.bjj-row', '.tier', '.j-card', '.step',
    '.container > h2', '.container > p', '.container-narrow > h2', '.container-narrow > p',
    '.hero__meta-item', '.hero__ctas', '.site-footer__cols > div',
    '[data-reveal]'
  ].join(', ');

  function tag(root) {
    var nodes = [];
    if (root.matches && root.matches(SEL)) nodes.push(root);
    if (root.querySelectorAll) nodes = nodes.concat([].slice.call(root.querySelectorAll(SEL)));
    // Direct children of section containers, so inline-styled blocks move too.
    if (root.querySelectorAll) {
      [].slice.call(root.querySelectorAll('section .container, section .container-narrow')).forEach(function (c) {
        [].slice.call(c.children).forEach(function (ch) { nodes.push(ch); });
      });
      // Grids inside sections: stagger their tiles.
      [].slice.call(root.querySelectorAll('section [style*="grid-template-columns"]')).forEach(function (g) {
        var kids = [].slice.call(g.children);
        var cols = (getComputedStyle(g).gridTemplateColumns || '').split(' ').length;
        kids.forEach(function (ch, i) {
          if (ch.hasAttribute('data-rv')) return;
          // Rows of tiles rise; two-column splits come in from the sides.
          var dir = cols >= 3 ? (i % 2 ? 'tilt' : 'up') : (i % 2 ? 'right' : 'left');
          ch.setAttribute('data-rv', dir);
          ch.style.transitionDelay = Math.min(i, 7) * 110 + 'ms';
          if (/^0?[1-9]$/.test((ch.textContent || '').trim().slice(0, 2))) ch.classList.add('step-in');
          nodes.push(ch);
        });
      });
      // Two-column splits (text left, panel right) get opposite entrances.
      [].slice.call(root.querySelectorAll('section .container > div[style*="grid-template-columns: 1fr 1fr"]')).forEach(function (g) {
        [].slice.call(g.children).forEach(function (ch, i) {
          ch.setAttribute('data-rv', i ? 'right' : 'left');
        });
      });
    }
    nodes.forEach(function (el) {
      if (!el || el.__rv) return;
      if (el.closest && el.closest('.site-header, .tweaks-panel, .promo, .bjj-drawer, .drawer, .shopify-section-group-header-group, .shopify-section-group-footer-group')) return;
      var r = el.getBoundingClientRect();
      if (r.height < 12 && r.width < 12) return;
      el.__rv = true;
      if (!el.hasAttribute('data-rv')) {
        var cn = el.className && el.className.baseVal === undefined ? String(el.className) : '';
        if (/section-head/.test(cn)) el.setAttribute('data-rv', 'up');
        else if (/bjj-media-slot/.test(cn)) el.setAttribute('data-rv', 'wipe');
        else if (/photo|prod-card/.test(cn)) el.setAttribute('data-rv', 'pop');
        else el.setAttribute('data-rv', 'up');
      }
      if (/^\d{1,4}$/.test((el.textContent || '').trim()) && parseFloat(getComputedStyle(el).fontSize) >= 30 && !el.__count) {
        el.__count = true;
        el.setAttribute('data-count', el.textContent.trim());
      }
      if (r.top < window.innerHeight * 0.94 && r.bottom > 0) {
        requestAnimationFrame(function () { el.classList.add('is-in'); showWords(el); if (el.hasAttribute('data-count')) countUp(el); });
      } else if (io) {
        io.observe(el);
      }
    });
  }

  // Photos hold still while the words move past them.
  function pinMedia(root) {
    [].slice.call(root.querySelectorAll('section [style*="grid-template-columns"], section .split')).forEach(function (g) {
      var kids = [].slice.call(g.children);
      if (kids.length !== 2) return;
      if (g.__pinned) return;
      var media = kids.filter(function (k) {
        return k.querySelector('img, .photo, [class*="photo"], canvas, svg') ||
               (k.classList && k.classList.contains('photo'));
      });
      if (media.length !== 1) return;
      var other = kids[kids.indexOf(media[0]) === 0 ? 1 : 0];
      if (media[0].offsetHeight < 180) return;
      if (other.offsetHeight < media[0].offsetHeight + 40) return;
      g.__pinned = true;
      media[0].classList.add('pin-media');
    });

    // Short intro column beside a long one: hold the intro while the list scrolls.
    [].slice.call(root.querySelectorAll('section [style*="grid-template-columns"], section .split')).forEach(function (g) {
      if (g.__pinned || g.children.length !== 2) return;
      var a = g.children[0], b = g.children[1];
      var short = a.offsetHeight <= b.offsetHeight ? a : b;
      var long = short === a ? b : a;
      if (short.offsetHeight < 160 || short.offsetHeight > long.offsetHeight * 0.68) return;
      if (long.offsetHeight < 520) return;
      g.__pinned = true;
      short.classList.add('pin-media');
    });
  }

  // Headings arrive word by word. Inline markup (em, strong, a, br) survives:
  // we only ever wrap the words inside text nodes, never restructure the element.
  function splitHeads(root) {
    [].slice.call(root.querySelectorAll('h1:not(.hero__display), h2')).forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      var txt = (h.textContent || '').trim();
      if (!txt || txt.length > 220) return;
      if (h.querySelector('svg, img, input, button')) return;
      if (h.closest('.site-header, .drawer, .tweaks-panel')) return;

      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null);
      var texts = [], n;
      while ((n = walker.nextNode())) texts.push(n);
      if (!texts.length) return;

      var i = 0;
      texts.forEach(function (node) {
        var parts = node.nodeValue.split(/(\s+)/);
        if (parts.length === 1 && !parts[0].trim()) return;
        var frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (!p) return;
          if (!p.trim()) { frag.appendChild(document.createTextNode(p)); return; }
          var s = document.createElement('span');
          s.className = 'w';
          s.textContent = p;
          s.style.transitionDelay = Math.min(i, 14) * 55 + 'ms';
          i++;
          frag.appendChild(s);
        });
        node.parentNode.replaceChild(frag, node);
      });

      h.setAttribute('data-split', 'done');
      if (!h.hasAttribute('data-rv')) h.setAttribute('data-rv', 'tilt');
    });
  }

  // Big plain numbers count up once.
  function countUp(el) {
    var target = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
    if (!target || target > 9999) return;
    var t0 = null, dur = 1200;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * e));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function autoParallax(root) {
    [].slice.call(root.querySelectorAll('section .photo, section [class*="photo--"], section img:not(.hero__img):not(.brand-mark img)')).forEach(function (el) {
      if (el.hasAttribute('data-parallax') || el.__px) return;
      if (el.closest('.site-header, .drawer, .prod-card')) return;
      if (el.getBoundingClientRect().height < 60) return;
      el.__px = true;
      el.setAttribute('data-parallax', '22');
    });
  }

  function showWords(el) {
    if (!el || el.getAttribute('data-split') !== 'done') return;
    [].slice.call(el.querySelectorAll('.w')).forEach(function (w) {
      w.style.opacity = '1';
      w.style.transform = 'none';
    });
  }

  function syncWords() {
    [].slice.call(document.querySelectorAll('[data-split="done"]')).forEach(function (h) {
      var b = h.getBoundingClientRect();
      if (h.classList.contains('is-in') || (b.top < window.innerHeight * 0.94 && b.bottom > 0)) showWords(h);
    });
  }

  function scan() {
    splitHeads(document.body);
    syncWords();
    autoParallax(document.body);
    pinMedia(document.body);
    tag(document.body);
    onScroll();
    clearTimeout(safety);
    safety = setTimeout(function () {
      document.querySelectorAll('[data-rv]').forEach(function (e) { e.classList.add('is-in'); });
    }, 3000);
  }
  var safety;

  var pending;
  var mo = new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(scan, 90);
  });

  function start() {
    var root = document.getElementById('MainContent') || document.body;
    if (!root) { setTimeout(start, 120); return; }
    scan();
    [400, 1000, 2000, 3500].forEach(function (t) { setTimeout(scan, t); });
    window.addEventListener('resize', function () { clearTimeout(pending); pending = setTimeout(scan, 200); });
    mo.observe(root, { childList: true, subtree: true });
  }
  start();

  document.addEventListener('shopify:section:load', function () { setTimeout(function(){ try { scan(); } catch(e){} }, 60); });
  document.addEventListener('shopify:section:select', function () { setTimeout(function(){ try { scan(); } catch(e){} }, 60); });
})();
